@import "./variants/zero-result.scss";
@import "./variants/loading-result.scss";
@import "./parts/animated-tag.scss";
@import "./data-views/result-data-presentation.scss";
@import "../../conversational-search-messages/messages-dynamic/suggestions/suggestions-card/suggestions-card.scss";
@import "../../../../../styles/variables";

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 117, 163, 0.4);
    border-radius: 12px;
  }

  70% {
    box-shadow: 0 0 0 10px rgba(0, 117, 163, 0);
    border-radius: 12px;
  }

  100% {
    box-shadow: 0 0 0 0 rgba(0, 117, 163, 0);
    border-radius: 12px;
  }
}

@keyframes fade-opacity {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.conversational-search-banner-dynamic {
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;

  @media (max-width: $uiaas-tablet) {
    display: inline-block;
    margin: 24px 0;
    width: 100%;
  }

  &-main {
    background-color: #ffffff;
    border: 1px solid #ced3d6;
    border-radius: 12px;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    padding: 24px;
    min-height: 50px;

    @media (max-width: $uiaas-tablet) {
      padding: 16px;
    }

    uiaas-search-widget-conversational-search-dynamic-banner-data-result {
      max-width: 100%;
    }

    host {
      width: 100%;
    }

    &-header {
      display: flex;
      background-color: #ffffff;
      border: none;
      cursor: pointer;
      justify-content: space-between;
      padding: 0;
      width: 100%;

      &__intro {
        align-items: center;
        display: flex;

        qds-title {
          margin-left: 8px;
        }

        qds-tag {
          animation: fade-opacity 0.7s ease-out;
        }
      }
    }

    &-content {
      margin-top: 24px;

      @media (max-width: $uiaas-tablet) {
        margin-top: 16px;
      }
    }

    &--initial {
      qds-button {
        animation: pulse 2s infinite;
      }
    }
  }

  &-footer {
    margin-top: 8px;
  }

  &-row {
    display: inline-flex;
    max-width: 708px;
    width: 100%;
  }

  &-input {
    width: 100%;

    &-button {
      border-left: 0px;
    }
  }

  &-group {
    width: 100%;
  }
}
